export default __webpack_public_path__ + "static/tag-do-5-dark-c065ce1b7e1df781d2409f21d5f84c842efd2fb51c5a256a99a859811b82c103.png";